import { Link as DomLink } from 'react-router-dom';
import { AppBar, Avatar, IconButton, Link, Toolbar, Typography } from '@mui/material';
import { Wrapper } from './NabBar.style';

interface IComponentProps { }

const MenuBar: React.FC<IComponentProps> = function () {
  return (
    <Wrapper>
      <div className='navbar'>
        <AppBar position='static'>
          <Toolbar>
            <IconButton
              edge='start'
              color='inherit'
              aria-label='menu'
              className='menu-button'
            />
            <Typography variant='h6' className='title'>
              <Avatar className="logo" variant="square" src="/logo512.png" />
              <Link
                component={DomLink}
                to={'/'}
                color='inherit'
                underline='none'
              >
                AIT Cloud Monitor
              </Link>
            </Typography>
          </Toolbar>
        </AppBar>
      </div>
    </Wrapper>
  );
};

export { MenuBar };
